import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledAgendaSidebarViewAccordionWrapper = styled.div`
    width: 100%;
`

export const StyledViewAccordionButton = styled(Button)(
    ({theme: {palette, spacing, opacities}}) => css`
        position: sticky;
        background-color: ${palette.neutral['50']}${opacities[60]};
        backdrop-filter: blur(8px);
        top: 0;
        width: 100%;
        font-weight: 500;
        color: ${palette.neutral['600']};
        justify-content: space-between;
        padding: ${spacing * 2}px 0;

        &:hover {
            color: ${palette.neutral['900']};
        }
    `
)
